var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogressWorkOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 17.4004C5.55396 17.7709 4.5 18.3403 4.5 18.9787C4.5 20.0953 7.72355 21.0004 11.7 21.0004C15.6765 21.0004 18.9 20.0953 18.9 18.9787C18.9 18.3403 17.846 17.7709 16.2 17.4004",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.95 9.30078C13.95 10.5434 12.9426 11.5508 11.7 11.5508C10.4573 11.5508 9.44995 10.5434 9.44995 9.30078C9.44995 8.05814 10.4573 7.05078 11.7 7.05078C12.9426 7.05078 13.95 8.05814 13.95 9.30078Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8316 16.9442C12.528 17.2366 12.1223 17.4 11.7001 17.4C11.2778 17.4 10.8721 17.2366 10.5685 16.9442C7.78877 14.2507 4.06357 11.2417 5.88024 6.87336C6.86249 4.51139 9.22035 3 11.7001 3C14.1798 3 16.5376 4.5114 17.5198 6.87336C19.3342 11.2363 15.6181 14.26 12.8316 16.9442Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogressWorkOrder);
export default __webpack_public_path__ + "static/media/inprogressWorkOrder.dee636a393cf7cedfe02d123d7801b3c.svg";
export { ForwardRef as ReactComponent };